import React, {useState} from "react";
import ActionsCascadeList from "../../action/ActionsCascade/ActionsCascadeList";
import sub_target from "../../../images/OKR/sub_target.svg";
import accountSVG from "../../../images/account.svg";
import updateIMG from "../../../images/update.svg";
import styled, {css} from "styled-components";
import {getImage} from "../../../utils/utils";
import {getDateInFrench, getLateInfo} from "../../../utils/dateUtils";
import Advancement from "../../objective/advancement/Advancement";
import AddButtonFullText from "../../buttons/AddButtonFullText";
import ActionOkrModal from "../../modal/action/ActionOkrModal";
import {DisplayForHead} from "../../../permissions/DisplayAccordingToRole";
import DeleteButton from "../../buttons/DeleteButton";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {deleteIndicator, loadIndicator} from "../indicatorsAction";
import YesNoModal from "../../modal/YesNoModal";
import IndicatorModal from "../../modal/IndicatorModal";
import InformationalModal from "../../modal/InformationalModal";
import Statistics from "../../objective/Statistics";
import {loadAllObjectives} from "../../objective/ObjectiveActions";
import {OKR_ROUTE} from "../../../routes/routesName";
import {loadProject} from "../../project/one-project/projectAction";
import SeeMoreButton from "../../buttons/SeeMoreButton";
const IndicatorCascadeCard = ({indicator, fromProject, objective}) => {

    const [openAction, setOpenAction] = useState(false)
    const [openActionModal, setOpenActionModal] = useState(false);

    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
    const [openEditModal, setOpenEditModal] = useState(false)
    const [openInfoModal, setOpenInfoModal] = useState(false)
    const currentUser = useSelector(state => state.currentUser)
    const project = useSelector(state => state.project)
    const location = useLocation()
    const dispatch = useDispatch()

    const handleOpenAction = () => {
        setOpenAction(!openAction)
    }
    const handleOpenInfo = () => {
        setOpenInfoModal(true)
    }
    const updateIndicator = async () => {
        await dispatch(loadIndicator(indicator.id))
        setOpenEditModal(true)
    }
    const deleteRequest = async (id) => {
        try {
            if (currentUser.status === 200) {

                    await dispatch(deleteIndicator(id))

                if (location.pathname === OKR_ROUTE) {
                    dispatch(loadAllObjectives(currentUser.id))
                } else {
                    dispatch(loadProject(project.id))
                }
                setTimeout(() => setIsOpenDeleteModal(false), 500)
            }
        } catch {
            console.error("une erreur est survenue")
        }
    }
    const hasException = () => {
        //If the pilot of the item is the current user and
        // if the item is indicator and the OKRPilot (===main) is the current user
        // if we are in guided update the pilot and the copilot and the sponsor of the project have exception
        return indicator.pilot.id === currentUser.id || indicator?.OKRPilot?.id === currentUser.id || (project.id !== 0 ? project.pilot.id === currentUser.id : false) || (project?.copilot?.id ? project.copilot.id === currentUser.id : false) || (project.axisSponsor ? project.axisSponsor.id === currentUser.id : false)
    }
    const createNewAction = () =>{
        if(openActionModal){
            return <ActionOkrModal
                setOpenModal={setOpenActionModal}
                selectedActionId={0}
                inActionPage={false}
                keyResultsId={indicator.id}
            />
        }
    }
    const displayModal = () => {
        if (isOpenDeleteModal) {
            return (
                <YesNoModal
                    name={"ce résultat clé ?"}
                    setOpenModal={setIsOpenDeleteModal}
                    handleClickYesAction={deleteRequest}
                    id={indicator.id}
                />
            )
        }
        if (openEditModal) {
            return <IndicatorModal
                parentObjective={objective}
                indicatorId={indicator.id}
                setOpen={setOpenEditModal}
                projectId={project.id}
            />
        }
        if (openInfoModal){
            return <InformationalModal component={<Statistics id={indicator.id} setOpen={setOpenInfoModal}/>}
                                setOpen={setOpenInfoModal}/>
        }

    }
    return (
        <>
            <Container>
            {
                createNewAction()
            }
            <Card onClick={handleOpenAction}>
                <TopSection>
                    <FlexRow>
                        <img src={sub_target} alt={'icone pour OKR'}/>
                        <p className={"okr-name"}> {indicator.title} </p>
                    </FlexRow>
                    <FlexRow secondary>
                        <Date> {getDateInFrench(indicator.endDate)} </Date>
                        <Pilot>
                            <img className={'icon-pilot'}
                                 src={getImage(indicator.pilot.photo, accountSVG)}
                                 alt={`${indicator.pilot.firstName} ${indicator.pilot.lastName}`}
                            />
                            <p> {indicator.pilot.firstName === "Deleted" ? "Utilisateur supprimé" : indicator.pilot.firstName} {indicator.pilot.lastName === "User" ? "" : indicator.pilot.lastName} </p>
                        </Pilot>
                    </FlexRow>
                    <LastSection>

                        <Advancement
                            advancementType={indicator.advancementType}
                            advancement={indicator.advancement}
                            target={indicator.target}
                        />

                        <FlexRow className={'last-update'}>
                            <img src={updateIMG} alt={'icone mise à jour'}/>
                            <p className={"date"}>{getDateInFrench(indicator.lastUpdate)}</p>
                        </FlexRow>
                    </LastSection>
                </TopSection>
            </Card>
                    <ButtonsContainer>
                        <SeeMoreButton
                            setOpenModal={handleOpenInfo}
                            toolTipContent={"Statistiques"}
                        />
                        {
                            !fromProject &&
                            <>
                                <DisplayForHead

                                    hasException={hasException()}
                                    component={
                                        <UpdateIndicatorButton
                                            $mode={getLateInfo(indicator)}
                                            onClick={updateIndicator}
                                        >
                                            Mettre à jour
                                        </UpdateIndicatorButton>
                                    }
                                />
                                <DisplayForHead
                                    hasException={hasException()}
                                    component={
                                        <DeleteButton
                                            setOpenDeleteModal={setIsOpenDeleteModal}
                                        />
                                    }
                                />
                            </>
                        }
                    </ButtonsContainer>
            </Container>
            {
                displayModal()
            }
            {
                openAction &&
                <Children $mode={!fromProject ? "okr" : "project"}>
                    {
                        !fromProject &&
                        <AddButtonFullText
                            id={0}
                            setId={indicator.id}
                            setUpdate={() => setOpenActionModal(true)}
                            title={"Ajouter une action"}/>
                    }


                    <ActionsCascadeList
                        actions={indicator.actions}
                        fromProject={fromProject}
                    />
                </Children>

            }
        </>

    );
}

const Pilot = styled.div`
  display: flex;
  justify-content: flex-start;
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  background-color: var(--color-white);
  box-shadow: rgba(0, 0, 0, 0.12) 0 6px 16px;
  border-radius: 15px;
  cursor: pointer;

  &:hover {
    background: var(--color-grey-03)
  }

  p {
    text-align: center;
    font-size: 13px;
  }

  @media (min-width: 768px) {
    height: 100%;
  }
  @media (min-width: 1000px) {
    min-width: 90%;
    height: unset;
    min-height: 6rem;
    display: inline-grid;
    gap: 1rem;
    padding: 0.5rem 1rem ;
    p {
      text-align: start
    }
  }
`
const TopSection = styled.div`
  grid-template-columns: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1rem;
  padding: 1em;
  grid-row-gap: 0.5em;
  width: 100%;
  @media (min-width: 768px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    grid-template-rows: unset;
    gap: 1em;
  }
  @media (min-width: 1000px) {
    display: grid;
    grid-template-columns: 30% 25% 40%;
    grid-template-rows: unset;
    gap: 1em;
  }
`

const LastSection = styled.div`
  display: grid;
  gap: 1rem;
  opacity: 1;
  @media (min-width: 768px) {

    grid-template-columns: 70% 30%;
    width: 70%;
  }
  @media (min-width: 1000px) {
  : 70 % 30 %;
    width: unset;
  }
`

const UpdateIndicatorButton = styled.button`

  padding: 0.5rem;
  border: none;
  color: white;
  border-radius: 10px;
  cursor: pointer;
  margin-left: 0.5rem;
  ${(props) => {
    switch (props.$mode) {
        case "upToDate":
            return css`
          background-color: var(--color-green);
        `
        case "midLate":
            return css`
          background-color: var(--color-yellow);
        `
        case "highLate":
            return css`
          background-color: var(--color-red);
        `
        default:
            return css`
          color: black;
        `;
    }
}}
`;

const FlexRow = styled.div`
  display: flex;
  grid-template-columns: 20% 35% 35%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 1em;
  flex-grow:1;

  div {
    flex-grow: 0.5;
  }

  .okr-name {
    flex-grow: 1;
    font-weight: 700;
  }


  .icon-pilot {
    width: 2em;
    height: 2em;
    object-fit: cover;
    border-radius: 50%;
  }

  div {
    display: flex;
    align-items: center;
    gap: 0.5em;
  }

  @media (min-width: 768px) {
    flex-direction: row;
  }


`
const Children = styled.div`

  display: flex;
  flex-direction: column;
  gap:1rem;
  
  ${(props)=>{
    switch (props.$mode){
      case "okr":
          return css`
            margin-right: 3rem;
          `;
      case "project": 
          return css`
            margin-right: 0;
          `;
      default:
          return css``;
    }
  }
  }
  

`
const Date = styled.p`
  white-space: nowrap;
  font-size: 12px;

`
const Container = styled.div`
  display: flex;
  flex-direction: column-reverse;
  width: 100%;


  @media (min-width: 768px) {
    flex-direction: row;
  }
`
const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  @media (min-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`

export default IndicatorCascadeCard